<style scoped>
.header-div {
  font-size: 14px;
  color: var(--color-text-dark);
  font-weight: bold;
  /*margin-bottom: 20px;*/
}
.pnl-chart-box {
  height: 500px
}
.empty-data-desc {
  font-size: 20px;
  color: var(--color-neutral);
}
.empty-data-box {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
div {
  /*border: 1px solid pink;*/
}
</style>

<template>
  <div class="pnl-chart-box box symbbox">
    <div class="header-div">{{ $text.tr('PNL ПО ДНЯМ') }}, $</div>
    <div v-if="!this.statsdata.TotalPNLByDay.Labels || this.statsdata.TotalPNLByDay.Labels.length < 2" class="empty-data-box">
      <div>
        <img src="../../../assets/monitor.png" width="300px">
      </div>
      <div class="empty-data-desc">{{ $text.tr('Нет данных') }}</div>
    </div>
    <BarChart v-else :chart-data="barChartData" :options="barChartOptions"/>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator'
import BarChart from '@/components/MainPage/Stats/BarChart.vue'
import { StatsData } from '@/util/types'
import Util from '@/util/util'

// interface Util {
//   [key: string]: any
// }

@Component({
  components: {
    BarChart
  }
})
export default class PNLByDayBarChart extends Vue {
  barChartData = {
    labels: [''],
    datasets: [
      {
        backgroundColor: [this.dangerColor],
        data: ['0']
      }
    ]
  }

  barChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: false
    },
    scales: {
      yAxes: [{
        position: 'right',
        ticks: {
          beginAtZero: true,
          fontColor: '#6b74e7' // this here
        }
      }],
      xAxes: [{
        gridLines: {
          drawOnChartArea: false // only want the grid lines for one axis to show up
        }
      }]
    }
  }

  get statsdata () {
    // @ts-ignore
    return (this.$store.state.stats as StatsData)
  }

  get dangerColor () {
    // @ts-ignore
    return Util.getCssVariable('--color-danger-light')
  }

  get successColor () {
    // @ts-ignore
    return Util.getCssVariable('--color-success-light')
  }

  @Watch('statsdata')
  statsDataChanged () {
    this.updateBarChart()
  }

  @Watch('statsdata.PNLByDay')
  statsDataPnlChanged () {
    this.updateBarChart()
  }

  created () {
    this.updateBarChart()
  }

  updateBarChart () {
    // console.log('updateBarChart', this.statsdata.PNLByDay.Labels, this.statsdata.PNLByDay.Values)
    if (this.statsdata.PNLByDay.Values) {
      this.barChartData.labels = this.statsdata.PNLByDay.Labels
      this.barChartData.datasets[0].data = this.statsdata.PNLByDay.Values
      this.barChartData.datasets[0].backgroundColor = this.statsdata.PNLByDay.Values.map((value) => parseFloat(value) < 0 ? this.dangerColor : this.successColor)
    }
  }
}
</script>
